import { FormControlValidator } from '../use-form-control';

export function MaxLengthValidator(length: number, customMsg?: string): FormControlValidator {
  return (val) => {
    if (val && val.length && val.length > length) {
      return {
        valid: false,
        errors: [{ msg: customMsg || `This field cannot be more than ${length} characters.` }],
      };
    }
    return { valid: true };
  };
}
